import React from 'react';
import ForgotPasswordForm from '../../components/auth/ForgotPasswordForm';
const ForgotPassword = () => {
  return <div className="w-full py-16 bg-gray-100" data-id="element-599">
      <div className="container mx-auto px-4" data-id="element-600">
        <ForgotPasswordForm data-id="element-601" />
      </div>
    </div>;
};
export default ForgotPassword;